import CreateDownloadRequest from "./Request/CreateDownloadRequest";
import DownloadManagerRepository from "../Repository/DownloadManagerRepository";
import ResourceRepository from "../Repository/ResourceRepository";
import DocumentResourceRepository from "../Repository/DocumentResourceRepository";
import DocumentRepository from "../Repository/DocumentRepository";
import Document from "../Entity/Document";

export default class CreateDownload {
    public constructor(
        private resourceRepository: ResourceRepository,
        private documentResourceRepository: DocumentResourceRepository,
        private downloadManagerRepository: DownloadManagerRepository,
        private documentRepository: DocumentRepository,
    ) {
    }

    public create(request: CreateDownloadRequest): Document[] {
        const documents = this.createDocuments(request);

        this.resourceRepository.save(request.getResource());
        this.createDocumentResources(request);
        this.downloadManagerRepository.save(request.getDownloadManager());

        return documents;
    }

    private createDocumentResources(request: CreateDownloadRequest): void {
        for (const documentResource of request.getDocumentResources()) {
            this.documentResourceRepository.save(documentResource);
        }
    }

    private createDocuments(request: CreateDownloadRequest): Document[] {
        let position: number = this.documentRepository.getCount();
        let documents: Document[] = [];
        for (const document of request.getDocuments()) {
            document.setPosition(position);
            this.documentRepository.save(document);
            documents.push(document);
            position++;
        }

        return documents;
    }
}